import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* leaveSessionSaga() {
  yield call(SignalingSocket.send, { event: 'leaveSession' });
}
